import { useEffect, useState } from "react";

/** useDebouncedValue — отдаёт значение с задержкой, сбрасывая таймер на каждое изменение. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
